import { render, staticRenderFns } from "./imgsLook.vue?vue&type=template&id=3116b7c4&scoped=true&"
import script from "./imgsLook.vue?vue&type=script&lang=js&"
export * from "./imgsLook.vue?vue&type=script&lang=js&"
import style0 from "./imgsLook.vue?vue&type=style&index=0&id=3116b7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3116b7c4",
  null
  
)

export default component.exports